import VideoBreakModel from "./video_break";

class EpgHlsUrlModel {
    url: string;
    breaks: Array<VideoBreakModel>;

    constructor(data: any) {
        this.url = data?.url || '';
        this.breaks = (data?.breaks || []).map((b:any) => new VideoBreakModel(b));
    }
}

export default EpgHlsUrlModel;
